import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  segment: () => ({
    backgroundColor: theme.colors.gray.background,
    borderRadius: `${theme.sizes.radius}px`,
    // border: props.type === 3 ? `solid 1px ${theme.colors.background.border}` : 'none',
    display: 'flex',
    maxWidth: '100%',
  }),
}));

export default useStyle;
